import * as THREE from 'three';
import { gsap } from 'gsap';

export default function () {
	const container = document.getElementById('footer-waves');
	// const waterWavesNode = document.querySelector('.js-water-waves');
	const waterWavesRect = container.getBoundingClientRect();
	// const gui = new dat.GUI();

	const scene = new THREE.Scene();
	// scene.background = new THREE.Color(0xffffff);

	const camera = new THREE.OrthographicCamera(0, waterWavesRect.width, waterWavesRect.height, 0, -1000, 1000);

	console.log(waterWavesRect.width, waterWavesRect.height);
	// camera.position.z = 0;

	const renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true });
	renderer.setPixelRatio(window.devicePixelRatio);
	renderer.setSize(waterWavesRect.width, waterWavesRect.height);
	renderer.shadowMap.enabled = true;
	renderer.shadowMap.type = THREE.PCFSoftShadowMap;
	renderer.outputColorSpace = THREE.SRGBColorSpace;

	// const ambientLight = new THREE.AmbientLight(0xffffff);
	// scene.add(ambientLight);

	container.appendChild(renderer.domElement);

	const loader = new THREE.TextureLoader();

	// Water Waves
	const vertexShaderW = `
	varying vec2 vUv;
	void main() {
		gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
		vUv = uv;
	}
	`;
	const fragmentShaderW = `
	varying vec2 vUv;
	uniform float uTime;
	uniform float uStrength;
	uniform vec2 uResolution;
	void main() {

		vec3 uColor = vec3(0.00784314, 0.02352941, 0.09019608);

		vec2 center = vec2(0.5, 0.5);

		// 转换到 -1.0 ~ 1.0 的范围
		vec2 uv = vUv - center;

		// 宽高比修正（保持正圆）
		uv.x *= uResolution.x / uResolution.y;

		// 半径
		float r = length(uv);

		// 波动公式
		float wave = sin(r * 60.0 - uTime * 3.0);
		float attenuation = exp(-4.0 * r);
		float ripple = wave * attenuation * uStrength;

		// 输出颜色
		vec3 color = uColor + ripple * 0.15;
		gl_FragColor = vec4(color, 1.0);
	}
	`;

	const waterwG = new THREE.PlaneGeometry(waterWavesRect.width, waterWavesRect.height, 40, 40);
	const waterwM = new THREE.ShaderMaterial({
		uniforms: {
			uTime: { value: 0.0 },
			uStrength: { value: 0.5 },
			uResolution: { value: new THREE.Vector2(waterWavesRect.width, waterWavesRect.height) },
		},
		vertexShader: vertexShaderW,
		fragmentShader: fragmentShaderW,
	});
	const waterwMesh = new THREE.Mesh(waterwG, waterwM);
	waterwMesh.position.x = waterWavesRect.width / 2;
	waterwMesh.position.y = waterWavesRect.height / 2;
	scene.add(waterwMesh);

	const updateWaterW = () => {
		const waterWavesRect = container.getBoundingClientRect();
		waterwMesh.geometry.dispose();
		waterwMesh.geometry = new THREE.PlaneGeometry(waterWavesRect.width, waterWavesRect.height, 40, 40);
		waterwMesh.position.x = waterWavesRect.width / 2;
		waterwMesh.position.y = waterWavesRect.height / 2;
		waterwMesh.material.uniforms.uResolution.value = new THREE.Vector2(waterWavesRect.width, waterWavesRect.height);

		renderer.setSize(waterWavesRect.width, waterWavesRect.height);
		camera.right = waterWavesRect.width;
		camera.top = waterWavesRect.height;
		camera.updateProjectionMatrix();
	};

	window.addEventListener('resize', () => {
		// camera.aspect = window.innerWidth / window.innerHeight;
		updateWaterW();
	});

	const clock = new THREE.Clock();
	let delta = clock.getDelta();

	const animate = () => {
		requestAnimationFrame(animate);
		// controls.update();
		const time = clock.getElapsedTime();
		// console.log(time, performance.now() * 0.001);

		waterwMesh.material.uniforms.uTime.value = time;
		renderer.render(scene, camera);
	};
	animate();
}
